import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "golf-admin-roles-page" }
const _hoisted_2 = { class: "roles-header-cards" }
const _hoisted_3 = { class: "role-card" }
const _hoisted_4 = { class: "role-card-header" }
const _hoisted_5 = { class: "role-title admin-title" }
const _hoisted_6 = { class: "role-desc" }
const _hoisted_7 = { class: "role-card" }
const _hoisted_8 = { class: "role-card-header" }
const _hoisted_9 = { class: "role-title supervisor-title" }
const _hoisted_10 = { class: "role-desc" }
const _hoisted_11 = { class: "role-card" }
const _hoisted_12 = { class: "role-card-header" }
const _hoisted_13 = { class: "role-title operator-title" }
const _hoisted_14 = { class: "role-desc" }
const _hoisted_15 = { class: "team-management-section" }
const _hoisted_16 = { class: "section-header" }
const _hoisted_17 = { class: "stats-row" }
const _hoisted_18 = { class: "stat-item" }
const _hoisted_19 = { class: "stat-value" }
const _hoisted_20 = { class: "stat-item" }
const _hoisted_21 = { class: "stat-value" }
const _hoisted_22 = { class: "table-container" }
const _hoisted_23 = { class: "team-member-cell" }
const _hoisted_24 = { class: "member-info" }
const _hoisted_25 = { class: "member-name" }
const _hoisted_26 = { class: "member-email" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "last-active" }
const _hoisted_29 = { class: "action-links" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 3,
  class: "pagination-container"
}
const _hoisted_33 = { class: "pagination-info" }
const _hoisted_34 = {
  key: 0,
  class: "edit-dialog-content"
}
const _hoisted_35 = { class: "dialog-title" }
const _hoisted_36 = { class: "dialog-subtitle" }
const _hoisted_37 = {
  class: "form-group",
  style: {"margin-top":"24px"}
}
const _hoisted_38 = { class: "dialog-actions" }

import { ref, computed, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import CommonError from '@/components/CommonError.vue'
import Loader from '@/components/Loader.vue'
import GolfInviteForm from '@/components/GolfInviteForm.vue'
import { useGolfSecurityGroupStore } from '@/store/golf-security-group'
import { GolfRole, GolfStatus } from '@/models/golfAdmin'
import type { GolfAdmin } from '@/models/golfAdmin'
import { useGolfHeaderStore } from '@/store/golf-header'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const golfSecurityGroupStore = useGolfSecurityGroupStore()
const headerStore = useGolfHeaderStore()

// State
const users = computed(() => golfSecurityGroupStore.listModule.list)
const isLoading = computed(() => golfSecurityGroupStore.listModule.isLoading)
const isInitialLoadingDone = computed(() => golfSecurityGroupStore.listModule.isInitialLoadingDone)
const error = computed(() => golfSecurityGroupStore.listModule.error)

const showInviteDialog = ref(false)
const showEditRoleDialog = ref(false)
const editingUser = ref<GolfAdmin | null>(null)
const editingLoading = ref(false)

// Computed Stats
const activeAdminsCount = computed(() =>
  users.value.filter(
    u => (u.golf_role === GolfRole.SUPER_ADMIN || u.golf_role === GolfRole.ADMIN) && u.golf_status === 'active'
  ).length
)

const fieldPersonnelCount = computed(() =>
  users.value.filter(
    u => (u.golf_role === GolfRole.OPERATOR || u.golf_role === GolfRole.SUPERVISOR) && u.golf_status === 'active'
  ).length
)

// Methods
const onRetryPress = () => golfSecurityGroupStore.getUsers()

const getAvatarColor = (email: string) => {
  const colors = ['#f5d0a9', '#c4c8d4', '#e2e8f0', '#fed7aa', '#bae6fd']
  let hash = 0
  for (let i = 0; i < email.length; i++) hash = email.charCodeAt(i) + ((hash << 5) - hash)
  return colors[Math.abs(hash) % colors.length]
}

const getInitials = (email: string) => {
  const parts = email.split('@')[0].split(/[._-]/)
  return parts.length >= 2
    ? (parts[0][0] + parts[1][0]).toUpperCase()
    : email.slice(0, 2).toUpperCase()
}

const extractNameFromEmail = (email: string) => {
  const local = email.split('@')[0]
  return local.split(/[._-]/).map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(' ')
}

const getMemberName = (row: any) => {
  if (row.first_name || row.last_name) {
    return `${row.first_name || ''} ${row.last_name || ''}`.trim()
  }
  return extractNameFromEmail(row.email)
}

const formatRole = (role?: string) => {
  if (!role) return 'Viewer'
  const r = role.toLowerCase()
  if (r === 'super_admin' || r === 'admin') return 'Admin'
  if (r === 'operator') return 'Operator'
  if (r === 'supervisor') return 'Supervisor'
  return role.charAt(0).toUpperCase() + role.slice(1)
}

const getRolePermissions = (role?: string) => {
  const r = role?.toLowerCase()
  if (r === 'super_admin' || r === 'admin') {
    return '<span style="color: #64748b;">All Modules Enabled</span>'
  }
  if (r === 'supervisor') {
    return '<span style="color: #64748b;">Dashboard, Trips, Fleet Management, Financial Reports & Billing (Users Disabled)</span>'
  }
  if (r === 'operator') {
    return '<span style="color: #64748b;">Dashboard, Trips, Fleet Management Only</span> <span style="color: #ef4444;">(Tariff, Users & Manual Payments Blocked)</span>'
  }
  return '<span style="color: #64748b;">Read-only access</span>'
}

const openEditRole = (row: GolfAdmin) => {
  editingUser.value = { ...row }
  showEditRoleDialog.value = true
}

const saveEditRole = async () => {
  if (!editingUser.value) return
  editingLoading.value = true
  try {
    const updated = await golfSecurityGroupStore.updateUserStatus(editingUser.value.id, {
      golf_role: editingUser.value.golf_role,
      golf_status: editingUser.value.golf_status,
    })
    if (updated) {
      showEditRoleDialog.value = false
      golfSecurityGroupStore.getUsers()
    }
  } finally {
    editingLoading.value = false
  }
}

const revokeAccess = async (row: GolfAdmin) => {
  try {
    await ElMessageBox.confirm(`Revoke access for ${extractNameFromEmail(row.email)}?`, 'Warning', {
      type: 'warning',
    })
    const updated = await golfSecurityGroupStore.updateUserStatus(row.id, {
      golf_role: row.golf_role,
      golf_status: GolfStatus.INACTIVE,
    })
    if (updated) {
      golfSecurityGroupStore.getUsers()
    }
  } catch (e) {
    if (e !== 'cancel') {
      console.error('Error revoking access:', e)
    }
  }
}

const handleInviteSuccess = () => {
  showInviteDialog.value = false
  golfSecurityGroupStore.getUsers()
}

onMounted(() => {
  headerStore.setHeaderInfo('golf.roles.title', false)
  golfSecurityGroupStore.getUsers()
})

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("img", {
            src: "/icons_golf_module/User role Admin.svg",
            class: "role-icon admin-icon",
            style: {"width":"24px","height":"24px","margin-right":"8px"},
            alt: "Admin"
          }, null, -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('golf.roles.admin')), 1)
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('golf.roles.full_system_access')), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[7] || (_cache[7] = _createElementVNode("img", {
            src: "/icons_golf_module/User role Supervisor.svg",
            class: "role-icon supervisor-icon",
            style: {"width":"24px","height":"24px","margin-right":"8px"},
            alt: "Supervisor"
          }, null, -1)),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('golf.roles.supervisor')), 1)
        ]),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('golf.roles.access_except_users')), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[8] || (_cache[8] = _createElementVNode("img", {
            src: "/icons_golf_module/User role Operator.svg",
            class: "role-icon operator-icon",
            style: {"width":"24px","height":"24px","margin-right":"8px"},
            alt: "Operator"
          }, null, -1)),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('golf.roles.operator')), 1)
        ]),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('golf.roles.operator_access_desc')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "stat-dot dot-orange" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.roles.total_active_admins')) + " ", 1),
            _createElementVNode("span", _hoisted_19, _toDisplayString(activeAdminsCount.value), 1)
          ]),
          _createElementVNode("span", _hoisted_20, [
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "stat-dot dot-blue" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.roles.total_active_field')) + " ", 1),
            _createElementVNode("span", _hoisted_21, _toDisplayString(fieldPersonnelCount.value), 1)
          ])
        ]),
        _createElementVNode("button", {
          class: "invite-new-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showInviteDialog.value = true))
        }, [
          _cache[11] || (_cache[11] = _createElementVNode("img", {
            src: "/icons_golf_module/User role Invite New Team Member - sent invitation.svg",
            alt: "Invite",
            style: {"width":"16px","height":"16px","margin-right":"4px","filter":"brightness(0) invert(1)"}
          }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.roles.invite_team_member')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        (error.value)
          ? (_openBlock(), _createBlock(CommonError, {
              key: 0,
              errorMessage: error.value,
              onRetryPress: onRetryPress
            }, null, 8, ["errorMessage"]))
          : (!isInitialLoadingDone.value)
            ? (_openBlock(), _createBlock(Loader, { key: 1 }))
            : _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                key: 2,
                data: users.value,
                class: "team-table"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('golf.roles.col_team_member'),
                    "min-width": "250"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", {
                          class: "member-avatar",
                          style: _normalizeStyle({ background: getAvatarColor(row.email) })
                        }, _toDisplayString(getInitials(row.email)), 5),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(getMemberName(row)), 1),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(row.email), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('golf.roles.role'),
                    "min-width": "150"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["role-badge", 'role-badge--' + (row.golf_role || 'viewer')])
                      }, _toDisplayString(formatRole(row.golf_role)), 3)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('golf.roles.col_module_permissions'),
                    "min-width": "300"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("div", {
                        class: "permissions-text",
                        innerHTML: getRolePermissions(row.golf_role)
                      }, null, 8, _hoisted_27)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('golf.roles.col_last_active_timestamp'),
                    "min-width": "200"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('golf.common.today')) + ", 07:14 ", 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('golf.fleet.actions'),
                    "min-width": "160",
                    align: "right"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("a", {
                          class: "action-link edit-link",
                          onClick: ($event: any) => (openEditRole(scope.row))
                        }, _toDisplayString(_ctx.$t('golf.common.edit')), 9, _hoisted_30),
                        _createElementVNode("a", {
                          class: "action-link revoke-link",
                          onClick: ($event: any) => (revokeAccess(scope.row))
                        }, _toDisplayString(_ctx.$t('golf.roles.revoke_access')), 9, _hoisted_31)
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_loading, isLoading.value]
              ]),
        (users.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('golf.trips.showing_results', {
                start: 1,
                end: users.value.length,
                total: users.value.length,
              })), 1),
              _createVNode(_component_el_pagination, {
                layout: "prev, pager, next",
                total: users.value.length,
                "page-size": 10,
                background: ""
              }, null, 8, ["total"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: showInviteDialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showInviteDialog).value = $event)),
      "custom-class": "modern-dialog",
      width: "480px",
      "show-close": false,
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(GolfInviteForm, {
          onSuccess: handleInviteSuccess,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (showInviteDialog.value = false))
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: showEditRoleDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showEditRoleDialog).value = $event)),
      "custom-class": "modern-dialog",
      width: "420px",
      "show-close": false
    }, {
      default: _withCtx(() => [
        (editingUser.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("h3", _hoisted_35, _toDisplayString(_ctx.$t('golf.roles.edit_team_member')), 1),
              _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t('golf.roles.update_role_for', {
              name: extractNameFromEmail(editingUser.value.email),
            })), 1),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.users.account_profile')), 1),
                _createVNode(_component_el_select, {
                  modelValue: editingUser.value.golf_role,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editingUser.value.golf_role) = $event)),
                  placeholder: _ctx.$t('golf.roles.select_role'),
                  class: "modern-select"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: 
                `${_ctx.$t('golf.roles.admin')} - ${_ctx.$t(
                  'golf.roles.role_admin_desc'
                )}`
              ,
                      value: "admin"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: 
                `${_ctx.$t('golf.roles.supervisor')} - ${_ctx.$t(
                  'golf.roles.role_supervisor_desc'
                )}`
              ,
                      value: "supervisor"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: 
                `${_ctx.$t('golf.roles.operator')} - ${_ctx.$t(
                  'golf.roles.role_operator_desc'
                )}`
              ,
                      value: "operator"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_el_button, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showEditRoleDialog.value = false)),
                  class: "cancel-btn"
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("Cancel")
                  ])),
                  _: 1,
                  __: [12]
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: saveEditRole,
                  loading: editingLoading.value,
                  class: "submit-btn"
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("Save Changes")
                  ])),
                  _: 1,
                  __: [13]
                }, 8, ["loading"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})